module.exports = __webpack_public_path__ + "static/media/debt-mortgage-v4.4edc3d3c.svg";